module.exports = __webpack_public_path__ + "img/30.a71d1d11.jpg";